import { createFileRoute } from "@tanstack/react-router"
import { SecurityActivityPage } from "@/pages/SecurityActivityPage"

export const Route = createFileRoute(
  "/_authenticated/_account/account-settings/security/activity-log"
)({
  component: SecurityActivityPage,
})
